export const bybitAccountCategory = 'bybit'

export const networkEvmChainIds: Record<string, number | undefined> = {
  ARBI: 42161,
  CAVAX: 43114,
  BASE: 8453,
  BERA: 80094,
  BSC: 56,
  ETH: 1,
  GLMR: 1284,
  LINEA: 59144,
  MANTA: 169,
  MANTLE: 5000,
  MATIC: 137,
  'MATIC.E': 137,
  MOVR: 1285,
  OAS: 248,
  OP: 10,
  SONIC: 146,
  TAIKO: 167000,
  ZKV2: 324,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {
  DOT: 0,
}

export const solanaNetwork = 'SOL'
